import { useQuery } from "@apollo/client";
import { PageLinksQuery } from "../../queries/pageQueries";

function usePageLinks({ pageId, locale }: { pageId: string; locale?: string }) {
  const { data, loading, error } = useQuery(PageLinksQuery, {
    skip: !pageId,
    variables: {
      pageId,
      locale,
    },
  });
  return { links: (data as any)?.pageLinks || [], loading, error };
}

export default usePageLinks;
